import {Form, Input, Select} from 'antd';
import FadeEffect from 'components/animation/fadeEffect';
import {fieldRules} from 'utils/helper';
import plusIcon from 'images/plus-circle.png';
import deleteIcon from 'images/delete.svg';
import styles from '../rewardSchemeTabs/newRewardSchemes.module.scss';

export const FeeWaiverConfiguration = ({form, hasReward, walletCurrencies}) => {
  const maxFeeWaivers = Form.useWatch('maxFeeWaivers', form) || [];

  if (!hasReward) {
    return null;
  }

  return (
    <div className={styles.configSection}>
      <div className={styles.sectionHeader}>
        <h1>Fee Waiver Configuration</h1>
      </div>
      <div className={styles['date-format']}>
        <Form.Item
          label="Percentage (percentage of transaction fee to be waived)"
          className={styles.field}
          name="percentage"
          rules={[fieldRules('percentage is required')]}>
          <Input type="number" min={0} max={100} />
        </Form.Item>
      </div>
      <>
        <h3 className={styles.title}>Maximum fee waiver for each currency</h3>
        <Form.List name="maxFeeWaivers">
          {(fields, {add, remove}) => (
            <>
              {fields.map(({key, name: fieldName}, index) => (
                <FadeEffect key={key}>
                  <div className={styles['key-facts']} key={key}>
                    <div>
                      <Form.Item
                        label="Currency"
                        name={[fieldName, 'currency']}
                        rules={[fieldRules('currency is required')]}>
                        <Select allowClear>
                          {walletCurrencies.map(({key, name}) => (
                            <Select.Option value={key} key={key}>
                              {name}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        label="Value"
                        name={[fieldName, 'value']}
                        rules={[fieldRules('value is required')]}>
                        <Input />
                      </Form.Item>
                      {(!maxFeeWaivers[index]?.currency ||
                        !maxFeeWaivers[index]?.value) && (
                        <span className={styles.warning}>
                          Please note both fields are required
                        </span>
                      )}
                    </div>
                    <img
                      onClick={() => remove(fieldName)}
                      src={deleteIcon}
                      alt=""
                    />
                  </div>
                </FadeEffect>
              ))}
              <div
                onClick={() => add({currency: '', value: ''})}
                className={styles['add-button']}>
                <img src={plusIcon} alt="" />
                <h1>Add Currency</h1>
              </div>
            </>
          )}
        </Form.List>
      </>
    </div>
  );
};
